import React, { useRef } from "react";
import { Box } from "@chakra-ui/react";
import {
  motion,
  useMotionValue,
  useSpring,
  useTransform,
  useReducedMotion,
} from "framer-motion";

const MotionBox = motion(Box);

const spring = { stiffness: 320, damping: 28, mass: 0.45 };

/**
 * Subtle pointer-reactive 3D tilt (falls back to a plain Box when reduced motion is on).
 */
export function TiltCard({ children, tilt = 9, style, ...rest }) {
  const ref = useRef(null);
  const reduceMotion = useReducedMotion();
  const x = useMotionValue(0.5);
  const y = useMotionValue(0.5);
  const rotX = useSpring(useTransform(y, [0, 1], [tilt, -tilt]), spring);
  const rotY = useSpring(useTransform(x, [0, 1], [-tilt, tilt]), spring);

  const onPointerMove = (e) => {
    if (reduceMotion || !ref.current) return;
    const r = ref.current.getBoundingClientRect();
    const w = Math.max(r.width, 1);
    const h = Math.max(r.height, 1);
    x.set((e.clientX - r.left) / w);
    y.set((e.clientY - r.top) / h);
  };

  const onPointerLeave = () => {
    x.set(0.5);
    y.set(0.5);
  };

  if (reduceMotion) {
    return (
      <Box ref={ref} {...rest}>
        {children}
      </Box>
    );
  }

  return (
    <MotionBox
      ref={ref}
      onPointerMove={onPointerMove}
      onPointerLeave={onPointerLeave}
      style={{
        rotateX: rotX,
        rotateY: rotY,
        transformPerspective: 980,
        transformStyle: "preserve-3d",
        ...style,
      }}
      {...rest}
    >
      {children}
    </MotionBox>
  );
}
